import { CASE_STUDY_LANG_EN } from "../../../helper/Constants";

export const fields = [
  {
    name: "chapters",
    type: "array",
    defaultValue: [],
    required: true,
  },  {
    name: "chapterTopics",
    type: "array",
    defaultValue: [],
    required: true,
  },
  {
    name: "marketType",
    type: "string",
    defaultValue: "b2b",
    required: true,
  },
  {
    name: "lang",
    type: "string",
    defaultValue: CASE_STUDY_LANG_EN,
    required: true,
  },
];

export const label = "General Information";
